<template>
  <div id="app">
      <router-view />
  </div>
</template>

<script>
export default {
    name: 'App',
    data(){
        return {

        }
    },
    created(){


    },

    components: {

    }
}
</script>

<style>
  #app {
    font-family: 'MicrosoftYaHei';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  body, div, dl, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, form, fieldset, input, textarea, p, blockquote, th, td {
    margin: 0;
    padding: 0;
  }
  * {
    touch-action: pan-x;
    touch-action: pan-y;
  }
  .flex_row{
    display: flex;
    flex-direction: row;
  }
  .flex_col{
    display: flex;
    flex-direction: column;
  }


  .NavMenu {
      width: 100%;
  }

  .NavMenu  .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #e6e6e6;

  }

  .NavMenu .el-tabs__item {
      font-size: 20px;
      font-weight: 400;
      height: 60px;
      line-height: 60px;
      padding: 0 30px;

  }

  .NavMenu .el-tabs__item:hover {
      color: #666;
  }

  .NavMenu .el-tabs__item.is-active {
      color: rgb(41, 104, 189);

  }

  .NavMenu .el-tabs__active-bar {
      background-color: rgb(41, 104, 189);
  }


</style>



// WEBPACK FOOTER //
// src/App.vue